import { Col, Image, Layout, Row, Carousel } from "antd";

import { motion } from "framer-motion";
import React from "react";
import "./Style.css";

import IMG1 from "../../assets/music/1.jpg";
import IMG2 from "../../assets/music/2.jpg";
import IMG3 from "../../assets/music/3.jpg";
import IMG4 from "../../assets/music/4.jpg";
import IMG5 from "../../assets/music/5.jpg";
import IMG6 from "../../assets/music/6.jpg";
const textContent = [
  "My love for traditional music blossomed in the warm corners of my grandmother's home. She adored “Xẩm”- the soulful folk songs of the blind traveling beggars of Northern Vietnam, and each evening, the hauntingly beautiful sound of the two-chord fiddle would fill our home. I remember making a promise to her: “When I grow up, I’ll play the two-chord fiddle and sing for you. We’ll form a band.” What began as a childhood promise slowly evolved into a genuine passion.",
  "As I grew older, I realized that my friends didn’t share this enthusiasm. They teased me, saying that the two-chord fiddle sounded strange and “outdated.” Though it saddened me, I didn’t give up. Instead, I practiced even harder. I began experimenting, playing modern songs on the two-chord fiddle, and discovered the surprising harmony between traditional and contemporary sounds. It was like building a bridge between my grandmother's generation and my own . To my surprise, my friends started listening—some even joined in. The once unfamiliar melodies of traditional music began to feel familiar to them. It was a joy to see how traditional sounds could connect generations, bringing my grandmother's songs into the present while honoring the past.",
  "Classical music captivated me from the moment I played a toy piano at a friend’s house. Entranced by its sound, I begged my mother for lessons, and by age four, my piano journey had begun.",
  "I started with basic lessons, but my passion quickly grew. From 2013 to 2019, I steadily progressed through the challenging levels of the ABRSM (Associated Board of the Royal Schools of Music) exams, ultimately achieving Grade 7. Every classical piece I played brought a deep sense of connection to another era, as if each note was a fragment of history. In 2022, all that dedication led me to the international stage, where I was awarded the Gold Medal at the Asia Pacific Arts Festival. Standing on that grand stage, I couldn’t help but reflect on the long journey that had brought me from the colorful keys of a toy piano to this incredible moment.",
];

const itemsSlide = [
  { id: 1, content: IMG2 },
  { id: 2, content: IMG3 },
  { id: 3, content: IMG4 },
  { id: 4, content: IMG5 },
];

const { Content } = Layout;
const MusicPage = () => {
  return (
    <Layout
      style={{
        backgroundColor: "#fff",
      }}
    >
      <Content style={{ textAlign: "center" }}>
        <Image
          className="w-full h-full"
          src={IMG1}
          alt="Image 2"
          preview={false}
        />
      </Content>
      <Content
        style={{
          padding: "40px 20px",
          maxWidth: "1400px",
          width: "100%",
          margin: "0 auto",
          overflow: "hidden",
        }}
      >
        <Row gutter={[30, 30]} align="middle">
          <Col xs={24} sm={24} md={12}>
            <div className="text-section">My Love for Traditional Melodies</div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <p
                className="text-color-2"
                style={{
                  display: "block",
                  marginBottom: "16px",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                {textContent[0]}
              </p>
            </motion.div>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Carousel autoplay arrows arrowSize={30}>
              {itemsSlide.map((item) => (
                <div key={item.id} style={{ border: "1px solid red" }}>
                  <img
                    src={item.content}
                    alt="Image slide"
                    key={item.id}
                    className="image-cover"
                  />
                </div>
              ))}
            </Carousel>
          </Col>
        </Row>

        <br />
        <br />
        <Row gutter={[30, 30]} align="middle">
          <Col>
            <div
              style={{
                padding: "20px",
                textAlign: "justify",
                backgroundColor: "#BFD1DB",
                borderRadius: "16px",
                fontSize: "16px",
              }}
            >
              {textContent[1]}
            </div>
          </Col>
        </Row>
        <br />
        <br />
        <Row gutter={[30, 30]} align="middle">
          <Col span={24}>
            <iframe
              className="responsive-iframe"
              width="100%"
              height="700"
              src="https://www.youtube.com/embed/EHFt2wXN_VI?si=RqXlU9snHmTDwm7Q"
              title="Vietnames two chord fiddle"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </Col>
        </Row>
        <br />
        <br />
        <Row gutter={[30, 30]} align="middle">
          <Col>
            <div className="text-section">
              Music flows from the East to the West
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <p
                className="text-color-2"
                style={{
                  display: "block",
                  marginBottom: "16px",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                {textContent[2]}
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <p
                className="text-color-2"
                style={{
                  display: "block",
                  marginBottom: "16px",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                {textContent[3]}
              </p>
            </motion.div>
          </Col>
        </Row>
        <br />
        <br />
        <Row gutter={[30, 30]}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={8}
            style={{
              textAlign: "center",
            }}
          >
            <Image
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              src={IMG6}
              alt="Image 6"
              preview={false}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={16}>
            <iframe
              width="100%"
              height="578"
              className="responsive-iframe"
              src="https://www.youtube.com/embed/zmQHUfytEcE?si=8YEtJSuzLizbs_ug"
              title="My journey with piano"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </Col>
        </Row>
        <br />
        <br />
        <Row gutter={[30, 30]}>
          <Col span={24}>
            <iframe
              width="100%"
              height="800"
              className="responsive-iframe"
              src="https://www.youtube.com/embed/3DoSWqVQ8Oc?si=QlcR6jKuQHtrONLg"
              title="Asia Pacific Arts Festival"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </Col>
        </Row>
        <br />
        <br />
      </Content>
    </Layout>
  );
};

export default MusicPage;
